import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import '@shopify/polaris/dist/styles.css';
import {AppProvider} from '@shopify/polaris';
import App from './App';
import Amplify, { API } from "aws-amplify";
import config from "./config";

Amplify.configure({
  API: {
    endpoints: [
      {
        name: "api",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
    ]
  }
});

// Checks if we've already installed the app before rendering it, and redirects to the install url if we have not
API.get("api", "/install" + window.location.search).then(response => {
  if(response) { // If we got back a response it's going to be a URL to redirect to
    window.top.location.href = response; // Redirect to the install screen
  } else { // Otherwise render the app
    ReactDOM.render(
      <AppProvider apiKey="30d93c083ce9066729dc42a0b9fc406b">
        <Router>
          <App />
        </Router>
      </AppProvider>,
      document.getElementById('root'),
    );
  }
}).catch(error => {
  console.log(error.response); // Otherwise log the error, if any
});
